var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Integration testing')},model:{value:(_vm.integrationTesting),callback:function ($$v) {_vm.integrationTesting=$$v},expression:"integrationTesting"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }